import Vue from "vue";
import Vuelidate from "vuelidate";
import "./public-path";
import "./MainMenu/index";

import { AmTypography } from "@afe/amui/src/components/Typography";
import { AmResponsive } from "@afe/amui/src/components/Responsive";
import {
  AmAccordion,
  AmAccordionItem
} from "@afe/amui/src/components/Accordion";
import { AmIcon } from "@afe/amui/src/components/Icon";
import { AmButton } from "@afe/amui/src/components/Button";

import ScrollButton from "./ScrollButton/index.vue";
import SearchButton from "./SearchButton/index.vue";
import AdmButton from "./AdmButton/index.vue";
import AdmTabsSlots from "./AdmTabsSlots/index.vue";
import Anchor from "./Anchor/index.vue";
import DocumentLink from "./DocumentLink/index.vue";
import ScrollButtonIcon from "./ScrollButtonIcon/index.vue";
import TabsSlots from "./TabsContent/TabsSlots.vue";
import HashBlocks from "./HashBlocks/HashBlocks.vue";
import HashBlock from "./HashBlocks/HashBlock.vue";
import { Swiper, SwiperSlide } from "./Swiper";
import HomeTabs from "./HomeTabs/HomeTabs.vue";
import VueQuotes from "./Quotes/Quotes.vue";
import CryptoWidget from "./CryptoWidget/CryptoWidget.vue";
import ButtonOnScroll from "./ButtonOnScroll/index.vue";
import Regulator from "./Regulator/index.vue";
import Hint from "./Hint/index.vue";
import Tip from "./Tip/index.vue";
import AccountTypes from "./AccountTypes/AccountTypes.vue";
import TabsContent from "./TabsContent/TabsContent.vue";
import TabsScroll from "./TabsScroll/TabsScroll.vue";
import ArticleShare from "./Article/Share.vue";
import FacebookIcon from "./Article/FacebookIcon.vue";
import LinkedinIcon from "./Article/LinkedinIcon.vue";
import CustomTabs from "./CustomTabs/index.vue";
import YoutubeVideo from "./YoutubeVideo/index.vue";
import TwitterIcon from "@/components/Article/TwitterIcon.vue";
import YoutubeIcon from "@/components/Article/YoutubeIcon.vue";
import TelegramIcon from "@/components/Article/TelegramIcon.vue";
import InstagramIcon from "@/components/Article/InstagramIcon.vue";
import SelectSwither from "./SelectSwither/index.vue";
import AdmAccordion from "./Accordion/Accordion.vue";
import AdmAccordionItem from "./Accordion/AccordionItem.vue";
import AdmTypography from "@afe/admirals-dev/src/components/AdmTypography";
import AdmIconButton from "@afe/admirals-dev/src/components/AdmIconButton";
import AdmSymbol from "@afe/admirals-dev/src/components/AdmSymbol";
import AdmMarketButton from "@afe/admirals-dev/src/components/AdmMarketButton";
import Details from "./Details/index.vue";
import TradeCharts from "./TradeCharts/TradeCharts.vue";
// @ts-ignore
Vue.use(Vuelidate);
Vue.config.productionTip = false;

const widgets: Record<string, any> = {
  accordion: AmAccordion,
  "scroll-button": ScrollButton,
  "document-link": DocumentLink,
  "ui-icon": AmIcon,
  regulator: Regulator,
  "tabs-slots": TabsSlots,
  "scroll-button-icon": ScrollButtonIcon,
  "hash-blocks": HashBlocks,
  "hash-block": HashBlock,
  anchor: Anchor,
  "home-tabs": HomeTabs,
  "app-quotes": VueQuotes,
  "crypto-widget": CryptoWidget,
  "trade-charts": TradeCharts,
  "button-on-scroll": ButtonOnScroll,
  "ui-button": AmButton,
  "am-tip": Tip,
  "am-responsive": AmResponsive,
  "swiper-widget": Swiper,
  "tabs-content": TabsContent,
  "tabs-scroll": TabsScroll,
  "article-share": ArticleShare,
  "facebook-icon": FacebookIcon,
  "linkedin-icon": LinkedinIcon,
  "twitter-icon": TwitterIcon,
  "youtube-icon": YoutubeIcon,
  "telegram-icon": TelegramIcon,
  "instagram-icon": InstagramIcon,
  "youtube-video": YoutubeVideo,
  "select-switcher": SelectSwither,
  "adm-accordion": AdmAccordion,
  "adm-tabs-slots": AdmTabsSlots,
  "adm-button": AdmButton,
  "adm-symbol": AdmSymbol,
  "adm-icon-button": AdmIconButton,
  "adm-market-button": AdmMarketButton,
  "details-widget": Details
};

const asyncWidgets: Record<string, any> = {
  sitemap: () => import("./Sitemap/index.vue"),
  instruments: () => import("./ContractSpecifications/Instruments.vue"),
  popup: () => import("./Popup/Index.vue"),
  "article-toc": () => import("./ArticleToc/ArticleToc.vue"),
  "article-list-content": () =>
    import("./ArticleListContent/ArticleListContent.vue"),
  "article-cards": () => import("./ArticleCards/ArticleCards.vue"),
  "article-card": () => import("./ArticleCards/ArticleCard.vue"),
  "analytic-news-cards": () =>
    import("./AnalyticNewsCards/AnalyticNewsCards.vue"),
  "education-cards": () => import("./EducationCards/EducationCards.vue"),
  "education-card": () => import("./EducationCards/EducationCard.vue"),

  "login-form": () => import("../forms/LoginForm/index.vue"),
  "sign-up-form-single": () => import("../forms/SignUpFormSingle/index.vue"),
  "sign-up-form-social": () => import("../forms/SignUpFormSocial/index.vue"),
  "sign-up-form-simple": () => import("../forms/SignUpFormSimple/index.vue"),
  "sign-up-form": () => import("../forms/SignUpForm/index.vue"),
  "education-form": () => import("../forms/EducationForm/index.vue"),
  "activate-lead-form": () => import("../forms/ActivateLeadForm/index.vue"),
  "partner-form": () => import("../forms/PartnerSignup/index.vue"),
  "demo-form": () => import("../forms/DemoForm/index.vue"),
  "metatrader-demo-form": () => import("../forms/MetatraderDemoForm/index.vue"),
  "crypto-form": () => import("../forms/CryptoForm/index.vue"),
  "premium-analytics-form": () => import("../forms/PremiumAnalytics/index.vue"),
  "affiliate-form": () => import("../forms/AffiliateSignup/index.vue"),
  "islamic-form": () => import("../forms/SignUpForm/index.vue"),
  "mt-se-form": () => import("../forms/MtSeForm/index.vue"),
  "ebook-form": () => import("../forms/EbookForm/index.vue"),
  "reset-password-form": () => import("../forms/ResetPassword/index.vue"),
  "webtrader-form": () => import("../forms/MTWebTrader/mt-webtrader-form.vue"),
  "mactrader-form": () => import("../forms/MacTraderForm/index.vue"),
  "campaign-form": () => import("../forms/CampaignForm/index.vue"),
  "invest-form": () => import("../forms/InvestForm/index.vue"),
  "subscription-form": () => import("../forms/SubscriptionForm/index.vue"),
  "demo-universal-form": () => import("../forms/DemoUniversalForm/index.vue"),
  "sign-up-form-finexware": () =>
    import("../forms/SignUpFormFinexware/index.vue"),
  "cert-popup": () => import("./ESG/CertPopup.vue"),
  "form-popup": () => import("./ESG/FormPopup.vue"),
  "youtube-full-width": () => import("./YoutubeFullWidth/YoutubeFullWidth.vue"),
  "app-banner": () => import("./AppBanner/index"),
  "details-widget": () => import("./Details/index.vue"),
  "version-switcher": () => import("./VersionSwitcher/index.vue"),
  "spain-popup-form": () => import("../forms/SpainPopUpForm/index.vue"),
  "country-switcher-dev-form": () =>
    import("../forms/CountrySwitcherDevForm/index.vue"),
  "spreads-comparison-table": () => import("./ZebraShadowTable/index.vue"),
  "stolen-accounts": () => import("./StolenAccounts/index.vue"),
  "blurred-modal": () => import("./BlurredModal/index.vue"),
  "regulator-dont-match": () => import("./RegulatorDontMatch/index.vue"),
  "calculator-widget": () => import("./CalculatorWidget/CalculatorWidget.vue"),
  "deposit-withdrawal": () => import("./DepositWithdrawal/Index.vue")
};

const components: Record<string, any> = {
  "am-icon": AmIcon,
  "accordion-items": AmAccordion,
  "accordion-item": AmAccordionItem,
  typography: AmTypography,
  "am-button": AmButton,
  "app-tabs-slots": TabsSlots,
  swiper: Swiper,
  "swiper-widget": Swiper,
  "swiper-slide": SwiperSlide,
  "app-scroll-button": ScrollButton,
  hint: Hint,
  "account-types": AccountTypes,
  "adm-accordion": AdmAccordion,
  "adm-accordion-item": AdmAccordionItem,
  "adm-typography": AdmTypography,
  "adm-symbol": AdmSymbol,
  "adm-tabs-slots": AdmTabsSlots,
  "crypto-widget": CryptoWidget,
  "adm-button": AdmButton,
  "adm-icon-button": AdmIconButton,
  "adm-market-button": AdmMarketButton
};

Object.keys(widgets).forEach(name => {
  [...document.getElementsByTagName(name)].forEach(el => {
    new Vue({
      el,
      components: {
        [name]: widgets[name],
        ...components
      }
    });
  });
});

Object.keys(asyncWidgets).forEach(name => {
  [...document.getElementsByTagName(name)].forEach(el => {
    asyncWidgets[name]().then((component: any) => {
      new Vue({
        el,
        components: {
          [name]: component.default,
          ...components
        }
      });
    });
  });
});
